export default {
  wrapper: {
    position: 'absolute',
    height: '100vh',
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'grey',
    opacity: 0.5,
    // zIndex: 100000,
    left: 0,
    right: 0,
  },
  container: {
    flex: 1,
    // width: 100,
    // height: 100,
    position: 'relative',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/LoadingOverlay/styles.js